import { RootState } from 'src/redux/createRootReducer'

import { AgentShortcut } from './agent.reducer'

export const selectIsAgentOpen = (state: RootState): boolean =>
  state.app.agent.isAgentOpen
export const selectAgentShortcut = (
  state: RootState,
): AgentShortcut | undefined => state.app.agent.shortcut
